import { Grid, TextField, Box, Button, Select, MenuItem, styled, Dialog, DialogTitle, DialogContent, Typography, DialogActions, Autocomplete, FormControlLabel, Checkbox } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { RobotoTypo } from '../../../utils/Typographies';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import { DatePicker } from '@mui/x-date-pickers';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import countryList from "react-select-country-list";
import axios from 'axios';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


function OfflineInfoSession({ activity, setActivity }) {
    const { state } = useLocation();
    const {courseId} = useParams();
    const [acceptTerms, setAcceptTerms] = useState(false);
      const navigate = useNavigate()
      console.log(activity)
const options = useMemo(() => countryList().getData(), []);
    const { t } = useTranslation()
    const userData = localStorage.getItem("student_data")
    ? JSON.parse(localStorage.getItem("student_data"))
    : "";
  console.log("userData ", userData);
    const [formDatas, setFormDatas] = useState({
        name: "",
        gender: "",
        nationality: "",
        dob: "",
        email: "",
        reEmail: "",
        phone: "",
        line: "",
        whatsapp: "",
        wechat: "",
        kakaotalk: "",
        zolo: "",
        registrationBy: "",
        highestEducationLevel: "",
        currentSchool: "",
        currentGrade: "",
        desiredProgramOfStudy: "",
        preferredDate: "",
        preferredTimeSlot: "",
        preferredPlatform: "",
        comments: ""
    })
const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [errors, setErrors] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)

    const RequiredIndicator = styled(Box)({
        color: "#FF202E",
        display: "inline-block",
    });

    const getCourseDetails = async () => {
            try {
              const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/get-consultation/${courseId}`
              );
              console.log(response, 'resp');
              if (response.data.success) {
                setActivity(response.data.data);
              }
            } catch (error) {
              console.log("Error fetching course details", error);
            }
          };
        
          useEffect(() => {
            getCourseDetails();
          }, [courseId]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormDatas(prev => ({
            ...prev,
            [name]: value
        }))
        
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    const handlePhoneChange = (value, country, event, formattedValue) => {
        setFormDatas(prev => ({
            ...prev,
            phone: value
        }))
        
        if (errors.phone) {
            setErrors(prev => ({
                ...prev,
                phone: ''
            }))
        }
    }

    const handleDateChange = (name, value) => {
        setFormDatas(prev => ({
            ...prev,
            [name]: value
        }))
        
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    const validateForm = () => {
        const newErrors = {}

        // Required fields validation
        if (!formDatas.name?.trim()) newErrors.name = 'Name is required'
        if (!formDatas.gender) newErrors.gender = 'Gender is required'
        if (!formDatas.nationality?.trim()) newErrors.nationality = 'Nationality is required'
        if (!formDatas.dob) newErrors.dob = 'Date of birth is required'
        if (!formDatas.email?.trim()) newErrors.email = 'Email is required'
        if (!formDatas.reEmail?.trim()) newErrors.reEmail = 'Please re-enter email'
        if (!formDatas.phone?.trim()) newErrors.phone = 'Phone number is required'
        if (!formDatas.registrationBy) newErrors.registrationBy = 'This field is required'
        if (!formDatas.highestEducationLevel) newErrors.highestEducationLevel = 'Education level is required'
        if (!formDatas.currentSchool?.trim()) newErrors.currentSchool = 'Current school is required'
        if (!formDatas.currentGrade?.trim()) newErrors.currentGrade = 'Current grade is required'
        if (!formDatas.desiredProgramOfStudy?.trim()) newErrors.desiredProgramOfStudy = 'Desired program is required'
        // if (!formDatas.preferredDate) newErrors.preferredDate = 'Preferred date is required'
        // if (!formDatas.preferredTimeSlot) newErrors.preferredTimeSlot = 'Preferred time slot is required'

        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (formDatas.email && !emailRegex.test(formDatas.email)) {
            newErrors.email = 'Please enter a valid email address'
        }

        // Email match validation
        if (formDatas.email && formDatas.reEmail && formDatas.email !== formDatas.reEmail) {
            newErrors.reEmail = 'Emails do not match'
        }

        // Phone validation (basic length check)
        if (formDatas.phone && formDatas.phone.length < 5) {
            newErrors.phone = 'Please enter a valid phone number'
        }

        // Date validation (check if date is not in the past for preferred date)
        // if (formDatas.preferredDate && new Date(formDatas.preferredDate) < new Date()) {
        //     newErrors.preferredDate = 'Preferred date cannot be in the past'
        // }

        // Date of birth validation (check if it's a valid past date)
        if (formDatas.dob && new Date(formDatas.dob) >= new Date()) {
            newErrors.dob = 'Date of birth cannot be in the future'
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        
        if(!userData && !userData._id){
            navigate('/login')
        }

        if (!validateForm()) {
            // Scroll to first error
            const firstErrorField = Object.keys(errors)[0]
            const element = document.querySelector(`[name="${firstErrorField}"]`)
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            return
        }

        setIsSubmitting(true)

        try {
            // Prepare data for API call
            const submissionData = {
                ...formDatas,
                applicationType: 'Offline Info Session',
                student_id : userData ? userData._id : null,
                application_id : activity._id,
                student_email : userData ? userData.email : null,
                student_name : userData ? userData.username : null,
                application_name : activity?.title?.en || null,
                // Format dates for API if needed
                dob: formDatas.dob ? new Date(formDatas.dob).toISOString() : null,
                preferredDate: formDatas.preferredDate ? new Date(formDatas.preferredDate).toISOString() : null,
                submittedAt: new Date().toISOString()
            }

            // Make API call
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/add-consultation-application`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(submissionData)
            })

            if (!response.ok) {
                throw new Error('Network response was not ok')
            }

            const result = await response.json()
            
            // Handle success
            console.log('Form submitted successfully:', result)
            
            // Reset form on successful submission
            setFormDatas({
                name: "",
                gender: "",
                nationality: "",
                dob: "",
                email: "",
                reEmail: "",
                phone: "",
                line: "",
                whatsapp: "",
                wechat: "",
                kakaotalk: "",
                zolo: "",
                registrationBy: "",
                highestEducationLevel: "",
                currentSchool: "",
                currentGrade: "",
                desiredProgramOfStudy: "",
                preferredDate: "",
                preferredTimeSlot: "",
                preferredPlatform: "",
                comments: ""
            })
            
            // Show success message to user
            setShowSuccessModal(true);

        } catch (error) {
            console.error('Error submitting form:', error)
            // Handle error - show error message to user
            alert('There was an error submitting the form. Please try again.')
        } finally {
            setIsSubmitting(false)
        }
    }

    // Error display component
    const ErrorMessage = ({ error }) => (
        error && (
            <Box sx={{ color: "#FF202E", display: "inline-block", mt: 0.5 }}>
                <RobotoTypo sx={{ fontSize: "14px" }}>{error}</RobotoTypo>
            </Box>
        )
    )

    return (
        <>
        <form onSubmit={handleSubmit}>
            <Grid
                container
                rowGap={3}
                columnGap={{ md: 14, sm: 13, lg: 19, xl: 24 }}
                padding="5% 10%"
            >
                <Grid xs={12} mb={2}>
                    <Box>
                        <RobotoTypo style={{ color: "#003B5C", fontSize: '25px', fontWeight: 700, }}>
                            {t("Personal details", { returnObjects: true })}
                        </RobotoTypo>
                    </Box>
                </Grid>

                {/* Name Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("ApplicationForm.name", { returnObjects: true })}{" "}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.name} 
                        name="name" 
                        onChange={handleChange}
                        error={!!errors.name}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                    <ErrorMessage error={errors.name} />
                </Grid>

                {/* Gender Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("RentingApplication.form.twofield4", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <Select
                        value={formDatas?.gender}
                        name="gender"
                        onChange={handleChange}
                        error={!!errors.gender}
                        fullWidth
                    >
                        <MenuItem value={'Male'}>
                            {t("Male", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'Female'}>
                            {t("Female", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'Other'}>
                            {t("Other", { returnObjects: true })}
                        </MenuItem>
                    </Select>
                    <ErrorMessage error={errors.gender} />
                </Grid>

                {/* Nationality Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("ApplicationForm.Nationality", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <Autocomplete
                          options={options}
                          autoHighlight
                          fullWidth
                          getOptionLabel={(option) => option.label} // Country name
                          value={
                            options.find((opt) => opt.label === formDatas?.nationality) || null
                          }
                          onChange={(e, value) => {
                            handleChange({
                              target: {
                                name: "nationality",
                                value: value ? value.label : "",
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                            //   label="Nationality"
                              error={!!errors.nationality}
                            />
                          )}
                        />
                    <ErrorMessage error={errors.nationality} />
                </Grid>

                {/* Date of Birth Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("ApplicationForm.dob", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={formDatas.dob}
                        onChange={(newValue) => handleDateChange('dob', newValue)}
                        format='DD/MM/YYYY'
                        maxDate={dayjs()}
                        slotProps={{
                            textField: {
                                // error: !!errors.dob,
                                // helperText: errors.dob,
                                fullWidth: true
                            }
                        }}
                    />
                    </LocalizationProvider>
                    <ErrorMessage error={errors.dob} />
                </Grid>

                {/* Email Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("ApplicationForm.email", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <TextField
                        value={formDatas.email}
                        name="email"
                        onChange={handleChange}
                        error={!!errors.email}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                    <ErrorMessage error={errors.email} />
                </Grid>

                {/* Re-enter Email Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("Re-enter Your Email", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <TextField
                        value={formDatas.reEmail}
                        name="reEmail"
                        onChange={handleChange}
                        error={!!errors.reEmail}
                        fullWidth
                    />
                    <ErrorMessage error={errors.reEmail} />
                </Grid>

                {/* Phone Field */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        mb={1.2}
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("Contact Phone Number", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <PhoneInput
                        value={formDatas.phone}
                        onChange={handlePhoneChange}
                        country={"sg"}
                        buttonStyle={{ border: "none" }}
                        inputStyle={{
                            height: "54px",
                            width: "100%",
                            marginTop: "10px",
                            borderRadius: "5px",
                            backgroundColor: "white",
                            boxShadow: "2px 2px 4px 0px #00000040 inset",
                            border: errors.phone ? '1px solid #FF202E' : '1px solid #C4C4C4',
                            "& fieldset": { border: "none" },
                            "& .MuiInputBase-input": {
                                padding: "14px 14px",
                            },
                        }}
                        countryCodeEditable={false}
                    />
                    <ErrorMessage error={errors.phone} />
                </Grid>

                {/* Social Media Fields - LINE */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("ApplicationForm.line", { returnObjects: true })}
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.line} 
                        name="line" 
                        onChange={handleChange}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                </Grid>

                {/* WhatsApp */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("contactUs.form.whatsapp", { returnObjects: true })}
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.whatsapp} 
                        name="whatsapp" 
                        onChange={handleChange}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                </Grid>

                {/* WeChat */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("ApplicationForm.wechat", { returnObjects: true })}
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.wechat} 
                        name="wechat" 
                        onChange={handleChange}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                </Grid>

                {/* KakaoTalk */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("RentingApplication.form.twofield13", { returnObjects: true })}
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.kakaotalk} 
                        name="kakaotalk" 
                        onChange={handleChange}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                </Grid>

                {/* Zalo */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("zalo", { returnObjects: true })}
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.zolo} 
                        name="zolo" 
                        onChange={handleChange}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                </Grid>

                {/* Registration By */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("registration_by", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <Select
                        value={formDatas?.registrationBy}
                        name="registrationBy"
                        onChange={handleChange}
                        error={!!errors.registrationBy}
                        fullWidth
                    >
                        <MenuItem value={'Student'}>
                            {t("Student", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'Parent'}>
                            {t("Parent", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'Guardian'}>
                            {t("Guardian", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'Other'}>
                            {t("Other", { returnObjects: true })}
                        </MenuItem>
                    </Select>
                    <ErrorMessage error={errors.registrationBy} />
                </Grid>

                {/* Educational Background Section */}
                <Grid xs={12} mb={2} mt={5}>
                    <Box>
                        <RobotoTypo style={{ color: "#003B5C", fontSize: '25px', fontWeight: 700, }}>
                            {t("Student Educational Background", { returnObjects: true })}
                        </RobotoTypo>
                    </Box>
                </Grid>

                {/* Highest Education Level */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("highest_edu_level", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <Select
                        value={formDatas?.highestEducationLevel}
                        name="highestEducationLevel"
                        onChange={handleChange}
                        error={!!errors.highestEducationLevel}
                        fullWidth
                    >
                        <MenuItem value={'ElementarySchool'}>
                            {t("Elementary School", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'MiddleSchool'}>
                            {t("Middle School", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'HighSchool'}>
                            {t("High School", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'University'}>
                            {t("University", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'GraduateSchool'}>
                            {t("Graduate School", { returnObjects: true })}
                        </MenuItem>
                        <MenuItem value={'Other'}>
                            {t("Other", { returnObjects: true })}
                        </MenuItem>
                    </Select>
                    <ErrorMessage error={errors.highestEducationLevel} />
                </Grid>

                {/* Current School */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("current_school", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.currentSchool} 
                        name="currentSchool" 
                        onChange={handleChange}
                        error={!!errors.currentSchool}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                    <ErrorMessage error={errors.currentSchool} />
                </Grid>

                {/* Current Grade */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("current_grade", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.currentGrade} 
                        name="currentGrade" 
                        onChange={handleChange}
                        error={!!errors.currentGrade}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                    <ErrorMessage error={errors.currentGrade} />
                </Grid>

                {/* Desired Program of Study */}
                <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("desired_program_of_study", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <TextField 
                        value={formDatas.desiredProgramOfStudy} 
                        name="desiredProgramOfStudy" 
                        onChange={handleChange}
                        error={!!errors.desiredProgramOfStudy}
                        fullWidth
                        inputProps={{ maxLength: 150 }}
                    />
                    <ErrorMessage error={errors.desiredProgramOfStudy} />
                </Grid>

                {/* Scheduling & Logistics Section */}
                {/* <Grid xs={12} mb={2} mt={5}>
                    <Box>
                        <RobotoTypo style={{ color: "#003B5C", fontSize: '25px', fontWeight: 700, }}>
                            {t("Scheduling & Logistics", { returnObjects: true })}
                        </RobotoTypo>
                    </Box>
                </Grid> */}

                {/* Preferred Date */}
                {/* <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("preferred_date", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <DatePicker
                        value={formDatas.preferredDate}
                        onChange={(newValue) => handleDateChange('preferredDate', newValue)}
                        shouldDisableDate={(date) => {
                            const disabledDates = activity?.leaveDates || [];

                            // Format date to YYYY-MM-DD
                            const formatted = dayjs(date).format("YYYY-MM-DD");

                            // 1. Disable dates present in leaveDates array
                            if (disabledDates.includes(formatted)) return true;

                            // 2. Disable past dates (anything before today)
                            const today = dayjs().startOf("day");
                            if (dayjs(date).isBefore(today)) return true;

                            return false;
                        }}
                        slotProps={{
                            textField: {
                                error: !!errors.preferredDate,
                                helperText: errors.preferredDate,
                                fullWidth: true
                            }
                        }}
                    />
                </Grid> */}

                {/* Preferred Time Slot */}
                {/* <Grid xs={12} md={5}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("preferred_time_slot", { returnObjects: true })}
                        <RequiredIndicator>*</RequiredIndicator>
                    </RobotoTypo>
                    <Select
                        value={formDatas?.preferredTimeSlot}
                        name="preferredTimeSlot"
                        onChange={handleChange}
                        error={!!errors.preferredTimeSlot}
                        fullWidth
                    >
                        {activity?.timeSlots?.map((slot, index) => (
                            <MenuItem key={index} value={slot}>
                                {slot}
                            </MenuItem>
                        ))}
                    </Select>
                    <ErrorMessage error={errors.preferredTimeSlot} />
                </Grid> */}

                {/* Comments Field */}
                <Grid xs={12}>
                    <RobotoTypo
                        sx={{
                            fontWeight: "500",
                            color: "#003B5C",
                            fontSize: "18px",
                            textAlign: "left",
                        }}
                    >
                        {t("comments", { returnObjects: true })}
                    </RobotoTypo>
                    <TextField
                        value={formDatas.comments}
                        name="comments"
                        onChange={handleChange}
                        multiline
                        rows={4}
                        fullWidth
                        placeholder="Any additional comments or questions..."
                        inputProps={{ maxLength: 500 }}
                    />
                </Grid>

                <Grid xs={12}>
                  <Box>
                    <RobotoTypo
                      style={{ color: "#003B5C", fontSize: "25px", fontWeight: 700 }}
                    >
                      {t("Registration Terms and Conditions", { returnObjects: true })}
                    </RobotoTypo>
                
                    <Box mt={2}>
                      {/* First LI with checkbox */}
                      <RobotoTypo>
                        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                          <li style={{ fontSize: "18px", display: "flex", alignItems: "flex-start" }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={acceptTerms}
                                  onChange={(e) => setAcceptTerms(e.target.checked)}
                                />
                              }
                              label={t("Please ensure that the contact information provided is accurate, so that we can successfully send the confirmation email and any subsequent notices.")}
                              sx={{
                                alignItems: "flex-start",
                                ml: 1,
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "18px",
                                  mt : 1
                                },
                              }}
                            />
                          </li>
                        </ul>
                      </RobotoTypo>
                
                      {/* Second LI without checkbox */}
                      <RobotoTypo style={{ marginTop: "10px" }}>
                        <ul>
                          <li style={{ fontSize: "18px", marginLeft: "10px" }}>
                        {t("If you do not receive the confirmation email, please check your spam folder or contact us to confirm the status of your registration.")}
                          </li>
                        </ul>
                      </RobotoTypo>
                    </Box>
                  </Box>
                </Grid>

                {/* Submit Button */}
                <Grid xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 5 }}>
                        <Button
                            type="submit"
                            variant='contained'
                            disabled={isSubmitting || !acceptTerms}
                            sx={{
                                minWidth: "200px",
                                borderRadius: "50px",
                                textTransform: 'none',
                                backgroundColor: '#177D84',
                                color: 'white',
                                fontSize: '18px',
                                ':hover': {
                                    backgroundColor: '#146b71'
                                },
                                ':disabled': {
                                    backgroundColor: '#cccccc'
                                }
                            }}
                        >
                            {isSubmitting ? 'Submitting...' : `${t("Register Now")}`}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
        <Dialog
  open={showSuccessModal}
  onClose={() => setShowSuccessModal(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle sx={{ textAlign: "center" }}>
    <TaskAltIcon color="success" sx={{ fontSize: 50 }} />
  </DialogTitle>

  <DialogContent>
    <Typography
      variant="h6"
      align="center"
      sx={{ fontWeight: 600, mb: 1 }}
    >
      Form Submitted Successfully!
    </Typography>

    <Typography align="center" sx={{ color: "gray" }}>
      Thank you for submitting. We will contact you soon.
    </Typography>
  </DialogContent>

  <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
    {/* <Button
      variant="contained"
      color="success"
      onClick={() => setShowSuccessModal(false)}
    >
    Close
    </Button> */}
    <Button
      variant="contained"
      color="success"
      onClick={() => navigate('/online-consultation')}
    >
    Move to Consultation
    </Button>
  </DialogActions>
</Dialog>
</>
    )
}

export default OfflineInfoSession;